import React, { Component } from "react";
import { Tab } from "semantic-ui-react";

import AnalyzerDPConfig from "./TsAnalyzerDPConfig";
import MonitorConfig from "./TsMonitorConfig";
import OpticFiberConfig from "./TsOpticFiberConfig";
import Strings from "utilities/StringSelector";

export class TsExpertConfig extends Component {

  componentDidMount() {
    sessionStorage.removeItem("auth");
  }
  
  render() {

    let panes = [];
    
    if (sessionStorage.getItem("isFiberProcessOn") === "true") {
      panes = [
        {
          menuItem: { key: "mn-protocol", content: Strings.MONITORING },
          render: () => <Tab.Pane> <MonitorConfig /> </Tab.Pane>
        },
        {
          menuItem: { key: "analyzer-dp", content: Strings.PHYS_MEDIUM },
          render: () => <Tab.Pane> <AnalyzerDPConfig /> </Tab.Pane>
        },
        {
          menuItem: { key: "optic-fiber", content: Strings.OPTIC_FIBER },
          render: () => <Tab.Pane> <OpticFiberConfig />  </Tab.Pane>
        }
      ];
    } else {
      panes = [
        {
          menuItem: { key: "mn-protocol", content: Strings.MONITORING },
          render: () => <Tab.Pane> <MonitorConfig /> </Tab.Pane>
        },
        {
          menuItem: { key: "analyzer-dp", content: Strings.PHYS_MEDIUM },
          render: () => <Tab.Pane> <AnalyzerDPConfig /> </Tab.Pane>
        }
      ];
    }

    return (
      <main style={mainContainerStyle}>
        <Tab
          panes={panes}
          renderActiveOnly={true} />
      </main>
    );
  }
}

const mainContainerStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

export default TsExpertConfig;